import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=2e2c8b5c&"
import script from "./SendOrder.vue?vue&type=script&lang=js&"
export * from "./SendOrder.vue?vue&type=script&lang=js&"
import style0 from "./SendOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports